/**
 * Cover Tabs script
 */
 class ME_CoverTabs {
  constructor() {
    this.initState();
    this.initEvents();
  }

  initState() {
    this.tablinksWrapper = $('.tabs__tablinks');
  }

  initEvents() {
    if (!this.tablinksWrapper) {
      return;
    }

    for (let i = 0; i < this.tablinksWrapper.length; i++) {
      if (!this.tablinksWrapper.eq(i).attr('data-js-initialized')) {
        this.tablinksWrapper.eq(i).attr('data-js-initialized', true);
        let tablinks = this.tablinksWrapper.eq(i).find('.tabs__tablinks-item');

        for (let j = 0; j < tablinks.length; j++) {
          tablinks.eq(j).on('click', this.showTab.bind(this));
        }
      }
    }
  }

  showTab(e) {
    let tabID = $(e.target).attr('data-id');
    let wrapper = $(e.target).parents('.cover-tabs');
    let wrapperID = wrapper.attr('data-tablinks');
    let tabContent = wrapper.find('.tabs__content[data-id="' + tabID + '"]');
    let tabs = wrapper.find('.tabs__tablinks-item');
    let content = wrapper.find('.tabs__content');

    if (tabID) {
      tabID = tabID.replace(/[^a-z0-9\-]/gmi, '');
    }

    if (wrapperID) {
      wrapperID = wrapperID.replace(/[^a-z0-9\-]/gmi, '');
    }

    for (let i = 0; i < tabs.length; i++) {
      tabs.eq(i).removeClass('is-active');
      content.eq(i).removeClass('is-showing');
      content.eq(i).removeClass('is-active');
      content.eq(i).attr('data-current-item', '0');
    }

    $(e.target).addClass('is-active');
    tabContent.addClass('is-active');

    setTimeout(() => {
      tabContent.addClass('is-showing');
    }, 200);
  }
}
